import { t } from "@/i18n-js/instance";
import { formatFileSize } from "@/react/helpers/fileSizeHelpers";
import { planFeatures } from "@/react/helpers/plansHelpers";

import { PlanFeatureFlag } from "../PlanFeatureFlag";

const GIGABYTE_TO_BYTES = 1024 * 1024 * 1024;

export const StorageRow = () => {
  const mapper = (value: number) => formatFileSize(value * GIGABYTE_TO_BYTES);

  return (
    <PlanFeatureFlag
      title={t("pricing_plans.feature.total_storage")}
      feature={planFeatures.included_storage_gigabytes}
      mapper={mapper}
    />
  );
};
